<div class="flex grow-0 flex-row items-center gap-4 w-full" [class.justify-end]="justifyEnd">
  <button
    (click)="submit(!allowResubmit)"
    [disabled]="submitting$ | async"
    [ngClass]="{ invalid: invalid }"
    color="primary"
    class="grow-0"
    mat-raised-button
    type="button"
  >
      <span class="flex flex-row items-center gap-2">
        <span class="grow-0">
          <ng-container>{{ submitButtonText }}</ng-container>
        </span>
        @if (submitting$ | async) {
          <mat-spinner [diameter]="15" color="accent" class="grow-0" mode="indeterminate"></mat-spinner>
        }
      </span>
  </button>
  @if (allowResubmit) {
    <button
      (click)="submit(true)"
      [disabled]="submitting$ | async"
      [ngClass]="{ invalid: invalid }"
      color="primary"
      class="grow-0"
      mat-raised-button
      type="button"
    >
        <span class="flex flex-row items-center gap-2">
          <span class="grow-0">
            <ng-container i18n>Submit and Close</ng-container>
          </span>
          @if (submitting$ | async) {
            <mat-spinner [diameter]="15" color="accent" class="grow-0" mode="indeterminate"></mat-spinner>
          }
        </span>
    </button>
  }
  @if (showResetButton) {
    <button
      (click)="reset()"
      [disabled]="submitting$ | async"
      class="grow-0"
      mat-stroked-button
      type="button"
    >
      <ng-container i18n>Reset</ng-container>
    </button>
  }
  @if (showCancelButton) {
    <button
      (click)="cancel()"
      [disabled]="submitting$ | async"
      color="warn"
      class="grow-0"
      mat-stroked-button
      type="button"
    >
      <ng-container i18n>Cancel</ng-container>
    </button>
  }
  @if (isDevMode) {
    <button (click)="logCurrentFormState()" mat-button type="button" class="grow-0">
      Current Form State
    </button>
  }
</div>
